class ProductYotpoReviews extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const observer = new MutationObserver(() => {
      const hasReviews = this.querySelector('.yotpo-review')

      if (hasReviews) {
        this.classList.remove('hidden')
        observer.disconnect()
      }
    })

    observer.observe(this, {
      childList: true,
      subtree: true,
    })
  }
}

customElements.define('product-yotpo-reviews', ProductYotpoReviews)
